// extracted by mini-css-extract-plugin
module.exports = {"SubNavigation_wrapper":"SubNavigation_SubNavigation_wrapper__zJgP_","Navigation_toolsDrawer":"SubNavigation_Navigation_toolsDrawer__iHAJJ"};